import '../../../../Styles/Toyota.scss'
import React from 'react';
import axios from 'axios';
import Image from 'react-bootstrap/Image';
import ResendLink from '../..//Shared/ResendLink';
import ToyotaLogo from '../../../../static/images/ty-login-logo.png'
import ActivateSuccess from '../../../Activate/ActivateSuccess'
import ActivateFailure from '../../../Activate/ActivateFailure'
import Loader from '../../../../static/images/loading.gif'
import AppVars from '../../../../AppVars.js'
import Logger from '../../../../Logger.js';
import { constants } from '../../../../constants/constants';

const appVars = AppVars.getInstance();


class ActivateAccountView extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            ...props,
        }
    }

    render() {
        return(
            <div>
                {/* HEADER AND TITLE RENDERING BASED ON STATE */}
                <div role = "banner">
                <div className={`title__TO ${this.props.activationLoading === true ? "block" : "none"}`} style={{'marginBottom': '0px', 'marginTop': '150px', 'width':'auto'}}>
                    {constants.ACTIVATE_LOADING_TITLE}
                </div>
                <div className={`${(this.props.pageLoading === true) && (this.props.activationLoading === false) ? "activate-background" : "none" }`}>
                    <div className="spinner">
                    <img className='spinner-img' src={Loader} alt='Loading'/>
                    </div>
                </div>
                <div className={`${this.props.pageLoading === true ? "block" : "none" }`}>
                    <div className="spinner">
                    <img className='spinner-img' src={Loader} alt='Loading' />
                    </div>
                </div>
                </div>
                {this.props.activationSuccess === true ? <ActivateSuccess redirectURI = {this.props.redirectURI} /> : null}
                {this.props.activationFailure === true ? <ActivateFailure /> : null}
            </div>
        )
    }

}

export default ActivateAccountView